import { useTheme } from "@mui/material";
import { Mail, MessageSquareText, Phone } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import {
	handleEmailClick,
	handlePhoneClick,
	handleSmsClick,
} from "web_myplann/Shared/Utils/openExternalApps";

type Props = {
	open: boolean;
	onClose: () => void;
	phone?: string;
	email?: string;
};

export const ContactDrawer: FC<Props> = ({ open, onClose, phone, email }) => {
	const { t } = useResource();
	const theme = useTheme();
	const iconColor = theme.palette.grey[600];

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			closeButton
			title={t(Resources.Common.contact)}
		>
			<ListRow
				icon={<Phone size={theme.iconSize.md} color={iconColor} />}
				title={t(Resources.Common.ToolbarMenu.Call)}
				subtitle={phone}
				onClick={() => handlePhoneClick(phone)}
			/>
			<ListRow
				icon={<MessageSquareText size={theme.iconSize.md} color={iconColor} />}
				title={t(Resources.Common.ToolbarMenu.WriteSMS)}
				subtitle={phone}
				onClick={() => handleSmsClick(phone)}
			/>
			<ListRow
				icon={<Mail size={theme.iconSize.md} color={iconColor} />}
				title={t(Resources.Common.ToolbarMenu.WriteEmail)}
				subtitle={email}
				isLast
				onClick={() => handleEmailClick(email)}
			/>
		</MyPlannDrawer>
	);
};
